export interface ReportListItem {
   id: number;

   owner_name: string;
   last_updated: string;

   name: string;

   shared: boolean;
   owned: boolean;
   pinned: boolean;
   is_scheduled: boolean;
}

export class ReportListItem implements ReportListItem {
   constructor( r?: ReportListItem ) {
      this.id = r?.id;
      this.owner_name = r?.owner_name;
      this.last_updated = r?.last_updated;
      this.name = r?.name;
      this.shared = r?.shared;
      this.owned = r?.owned;
      this.pinned = r?.pinned;
      this.is_scheduled = r?.is_scheduled;
   }
}
